module.exports = __webpack_public_path__ + "client booking calendar.svg?289c3a1785cd17c49aa3f54a812c973b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/client booking calendar.svg
// module id = 358
// module chunks = 0